<template>
  <v-app>
    <v-navigation-drawer
      app
      color="primary"
    >
    </v-navigation-drawer>
    <v-main class="derecha">
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
          >
            <v-card
              class="elevation-3"
              tile
            >
              <v-card-text>
                Gracias por utilizar el servicio.
              </v-card-text>
              <v-card-actions>
                <v-btn
                  outlined
                  :to="{ name: 'Login' }"
                >
                  Entrar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex';
import types from '@/types';

export default {
  methods: {
    ...mapActions({
      [types.LOGOUT]: `${types.USER}/${types.LOGOUT}`,
    }),
  },

  mounted() {
    this[types.LOGOUT]();
  },
};
</script>

<style>
.derecha {
  background-color: rgb(156, 153, 153);
}
</style>



// WEBPACK FOOTER //
// src/views/user/Logout.vue